export default {
    methods: {
        showMsgError ($el, formName, listMsg) {
            if (!listMsg) return
            if (listMsg instanceof Array) {
                listMsg.forEach(msg => {
                    let err = msg.split(':')
                    $el.$refs[formName].setErrorField(err[0].trim(), err[1].trim())
                })
                $el.alertMessage('入力情報を再度ご確認ください。', '入力情報エラー')
            } else {
                $el.alertMessage(listMsg, '入力情報エラー')
            }
        }
    }
}
